import Config from '../config'

/**
 * Load Zoho SalesIQ widget script and initialize with user data
 * @param {Object} user - The authenticated user object
 * @param {Function} callback - Callback function to execute after script loads
 */
export const loadZohoSalesIQ = (user, callback) => {
    if (!Config.zoho?.widgetCode) {
        // We don't need to load this script if we don't have a zoho widget code
        return
    }

    window.$zoho = window.$zoho || {}
    window.$zoho.salesiq = window.$zoho.salesiq || {
        widgetcode: Config.zoho.widgetCode,
        values: {},
        ready: () => {
            window.$zoho.salesiq.floatbutton.coin.hidetooltip()
            window.$zoho.salesiq.floatbutton.visible('hide')

            if (user) {
                window.$zoho.salesiq.visitor.name(`${user.first_name} ${user.last_name}`)
                window.$zoho.salesiq.visitor.firstname(user.first_name)
                window.$zoho.salesiq.visitor.lastname(user.last_name)
                window.$zoho.salesiq.visitor.email(user.email)
                window.$zoho.salesiq.visitor.contactnumber(user.phone_number)
            }
        },
    }

    const existingScript = document.getElementById('zsiqscript')
    if (!existingScript) {
        const script = document.createElement('script')
        script.type = 'text/javascript'
        script.defer = true
        script.src = 'https://salesiq.zoho.com/widget'
        script.id = 'zsiqscript'
        const n = document.getElementsByTagName('script')[0]
        if (n.parentNode) {
            n.parentNode.insertBefore(script, n)
        }

        script.onload = () => {
            if (callback) callback()
        }
    }

    if (existingScript && callback) callback()
}

/**
 * Open the Zoho SalesIQ chat window programmatically
 */
export const openZohoChat = () => {
    if (window.$zoho && window.$zoho.salesiq && window.$zoho.salesiq.floatwindow) {
        window.$zoho.salesiq.floatwindow.open()
    }
}

/**
 * Show the Zoho SalesIQ float button
 */
export const showZohoButton = () => {
    if (window.$zoho && window.$zoho.salesiq && window.$zoho.salesiq.floatbutton) {
        window.$zoho.salesiq.floatbutton.visible('show')
    }
}

/**
 * Hide the Zoho SalesIQ float button
 */
export const hideZohoButton = () => {
    if (window.$zoho && window.$zoho.salesiq && window.$zoho.salesiq.floatbutton) {
        window.$zoho.salesiq.floatbutton.visible('hide')
    }
}
